import React, { useMemo, useState } from "react";
import { useParams, useNavigate} from "react-router-dom";
import { useLocation } from "react-router-dom";
import { where } from "firebase/firestore";
import useFetchData from "../../hooks/ValuatorHooks/useFetchData";
import CaseDetailsComponent from '../../components/CaseComponents/CaseDetailsComponent'
import LoadingComponent from "../../components/LoadingComponent";
import useDeleteData from "../../hooks/ValuatorHooks/useDeleteData";
import Navbar from "../../components/ValuatorNavbar";


function CasePage({isArchived}) {
    const { caseId } = useParams();
    const navigateTo = useNavigate();
    const location = useLocation();
    const [selectedCompany, setSelectedCompany] = useState("m5");

    const companyQueryParams = useMemo(() => [where('company', '==', selectedCompany)], [selectedCompany]);
    const {
        data: companyData,
        loading: companyLoading,
        error: companyError
    } = useFetchData('companies', null, companyQueryParams);

    const companyID = companyData && companyData.length > 0 ? companyData[0].id : null;

    const caseDetailsPath = `companies/${companyID}/cases`;
    const {
        data: caseDetails,
        loading: caseLoading,
        error: caseError
    } = useFetchData(caseDetailsPath, caseId);

    const caseCollectionPath = `companies/${companyID}/cases`;
    const { deleteData, isLoading, error } = useDeleteData(caseCollectionPath);

    const {
        data: questions,
        loading: questionsLoading,
        error: questionsError
    } = useFetchData(companyID ? `companies/${companyID}/questions` : null);

    if (companyLoading || caseLoading || questionsLoading) {
        return <LoadingComponent />;
    }

    if (companyError || !companyData || companyData.length === 0) {
        return <p>Company details are not available or an error occurred: {companyError}</p>;
    }

    if (!caseDetails) {
        return <p>Case details are not available.</p>;
    }

    return (

      <>
        <Navbar />
        <CaseDetailsComponent
            caseDetails={caseDetails}
            questions={questions}
            navigateTo={navigateTo}
            deleteData={deleteData}
            isLoading={isLoading}
            error={error}
            isArchived={isArchived}
            companyID={companyID}
            caseId={caseId}
        />
      </>
    );
}

export default CasePage;

